import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-csv-export-progress',
  standalone: true,
  templateUrl: './csv-export-progress.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './csv-export-progress.component.scss'
})
export class CsvExportProgressComponent {
  @Input() current: number = 0;
  @Input() total: number = 0;

  get percent(): number {
    if (this.total <= 0) return 0;
    return Math.min(100, Math.round((this.current / this.total) * 100));
  }
}
